/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITableColumnsConfig, ITablesSlice } from './types';

const initialState: ITablesSlice = {
	configs: {}
};

const tablesSlice = createSlice({
	name: 'tables',
	initialState,
	reducers: {
		setTableConfig: (
			state,
			action: PayloadAction<{ key: string; config: ITableColumnsConfig }>
		) => {
			state.configs[action.payload.key] = action.payload.config;
		},
		clearTableConfig: (state, action: PayloadAction<string>) => {
			delete state.configs[action.payload];
		},
		// Cleared entirely at logout (dispatched from AuthProvider.applySignedOut).
		resetTablesConfig: () => initialState
	}
});

export const tablesActions = tablesSlice.actions;
export const tablesReducer = tablesSlice.reducer;
